// initial state
const state = {
    id: null,
    isAdmin: false,
    ihm: false,
    email: null,
    firstName: null,
    lastName: null,
    userGroups: ['trial']
}

// mutations
const mutations = {
    setId(state,id) {
        state.id = id
    },
    setEmail(state,email) {
        state.email = email
    },
    setFirstName(state,firstName) {
        state.firstName = firstName
    },
    setLastName(state,lastName) {
        state.lastName = lastName
    },
    setAdmin () {
        state.isAdmin = true
    },
    setIhm () {
        state.ihm = true
    },
    setGroups (state, groups) {
        state.userGroups = groups
        console.log(state.userGroups)
    }
}

export default {
namespaced: true,
state,
mutations
}